const LOGO_URL = 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/2e970e52-bbc6-4708-9dc9-30721acea5db_compressed_watermarked_img_8696222614542899108.webp';

const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Módulos', href: '#modulos' },
  { label: 'Beneficios', href: '#beneficios' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="relative bg-primary-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-18">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            {/* Brand */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={LOGO_URL}
                  alt="Acualys-Bo"
                  className="h-12 w-auto object-contain brightness-0 invert"
                />
              </div>
              <p className="text-sm text-white/60 leading-relaxed">
                Sistema integral de administración de agua para cooperativas, municipalidades y empresas privadas en Bolivia.
              </p>
            </div>

            {/* Links */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">
                Navegación
              </h4>
              <ul className="space-y-2">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-white/60 hover:text-accent-300 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-sm font-semibold text-white mb-4">
                Contacto
              </h4>
              <div className="space-y-3">
                <a
                  href="https://wa.me/59173455233"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-accent-300 transition-colors"
                >
                  <span className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-green-400" />
                  </span>
                  <span>WhatsApp Business</span>
                </a>
                <a
                  href="https://fluxbostudio.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-accent-300 transition-colors"
                >
                  <span className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                    <i className="ri-global-line text-accent-300" />
                  </span>
                  <span>fluxbostudio.com</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              © {new Date().getFullYear()} Acualys-Bo. Todos los derechos reservados.
            </p>
            <p className="text-xs text-white/40">
              Desarrollado por <a href="https://fluxbostudio.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 transition-colors">Fluxbo Studio</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}